import { Grid } from '@mui/material'
import React from 'react'
import Card from './Card'

type MetricCardsProps = {
	children?: React.ReactNode
	metrics: any[]
	handleOnClick?: () => void
}
export default function MetricCards({ children, metrics, handleOnClick }: MetricCardsProps) {
	return (
		<Grid
			container
			justifyContent="center"
			spacing={2}
			marginBottom="24px"
			marginTop="0px"
			marginRight="0px"
			marginLeft="0px"
			sx={{
				// width: '100%',
				width: 'calc(100% + 16px)',
				transform: 'translateX(-8px)',
			}}
		>
			{children
				? children
				: metrics.map((metric) => <Card metric={metric} key={metric.id} handleOnClick={handleOnClick} />)}
		</Grid>
	)
}
